import { Box, styled } from '@mui/material';

interface EmbedContainerProps {
  align?: string;
}

// Helper to filter out custom props
const shouldForwardEmbedProp = (prop: string) => !['align'].includes(prop);

export const StyledEmbedContainer = styled(Box, {
  shouldForwardProp: shouldForwardEmbedProp,
})<EmbedContainerProps>(({ align }) => ({
  margin: '2rem auto',
  width: '100%',
  maxWidth: '100%',
  position: 'relative',
  ...(align === 'center' && {
    textAlign: 'center',
    margin: '2rem auto',
  }),
  ...(align === 'left' && {
    marginRight: 'auto',
    marginLeft: 0,
  }),
  ...(align === 'right' && {
    marginLeft: 'auto',
    marginRight: 0,
  }),
  '.wp-has-aspect-ratio': {
    position: 'relative',
  },
  '.wp-embed-aspect-16-9': {
    paddingTop: '56.25%',
  },
  '.wp-embed-aspect-4-3': {
    paddingTop: '75%',
  },
  '.wp-embed-aspect-1-1': {
    paddingTop: '100%',
  },
  '.wp-embed-aspect-9-16': {
    paddingTop: '177.78%',
  },
  '.wp-embed-aspect-1-2': {
    paddingTop: '200%',
  },
  '.twitter-tweet': {
    margin: '0 auto !important',
  },
  '.fb_iframe_widget': {
    width: '100%',
    '& span, & iframe': {
      width: '100% !important',
    },
  },
  '& figcaption': {
    margin: '8px 0 0',
    fontSize: '0.875rem',
    color: '#555',
    textAlign: 'center',
  },
}));

export const StyledFallbackContainer = styled(Box)({
  padding: '24px',
  backgroundColor: '#f8f8f8',
  border: '1px solid #e0e0e0',
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  textAlign: 'center',
  '& a': {
    color: '#0073aa',
    textDecoration: 'none',
    fontWeight: 500,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});
